module.exports = __webpack_public_path__ + "static/media/private_game.092ae7a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/private_game.jpg
// module id = 820
// module chunks = 0